/* tslint:disable */
/* eslint-disable */
/**
 * pkg/api/event.proto
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: version not set
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    V1PersistentVolumeClaimTemplate,
    V1PersistentVolumeClaimTemplateFromJSON,
    V1PersistentVolumeClaimTemplateFromJSONTyped,
    V1PersistentVolumeClaimTemplateToJSON,
} from './V1PersistentVolumeClaimTemplate';

/**
 * 
 * @export
 * @interface V1EphemeralVolumeSource
 */
export interface V1EphemeralVolumeSource {
    /**
     * 
     * @type {V1PersistentVolumeClaimTemplate}
     * @memberof V1EphemeralVolumeSource
     */
    volumeClaimTemplate?: V1PersistentVolumeClaimTemplate;
}

export function V1EphemeralVolumeSourceFromJSON(json: any): V1EphemeralVolumeSource {
    return V1EphemeralVolumeSourceFromJSONTyped(json, false);
}

export function V1EphemeralVolumeSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): V1EphemeralVolumeSource {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'volumeClaimTemplate': !exists(json, 'volumeClaimTemplate') ? undefined : V1PersistentVolumeClaimTemplateFromJSON(json['volumeClaimTemplate']),
    };
}

export function V1EphemeralVolumeSourceToJSON(value?: V1EphemeralVolumeSource | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'volumeClaimTemplate': V1PersistentVolumeClaimTemplateToJSON(value.volumeClaimTemplate),
    };
}

